<router-outlet></router-outlet>
<app-full-loader></app-full-loader>
<app-chatbot-ai *ngIf="showChatbot"></app-chatbot-ai>
